<template>
  <div class="container">
    <Headers></Headers>
    <div class="center">
      <div class="banner">
        <img class="img" src="../assets/img/initiation/banner.png" />
      </div>
      <div class="block1">
        <div class="title">
          <img class="img" src="../assets/img/initiation/block1/title.png" />
        </div>
        <div class="icons-wrap">
          <div class="item">
            <div class="content" style="background-color: #fffbe5">
              <img
                class="icon"
                src="../assets/img/initiation/block1/icon1.png"
              />
              <p class="text">享受美好音乐生活</p>
            </div>
          </div>
          <div class="item">
            <div class="content" style="background-color: #fef7e5">
              <img
                class="icon"
                src="../assets/img/initiation/block1/icon2.png"
              />
              <p class="text">打下坚实的音乐基础</p>
            </div>
          </div>
          <div class="item">
            <div class="content" style="background-color: #fef1e8">
              <img
                class="icon"
                src="../assets/img/initiation/block1/icon3.png"
              />
              <p class="text">拥有艺术的美感能力</p>
            </div>
          </div>
          <div class="item">
            <div class="content" style="background-color: #f2fbe5">
              <img
                class="icon"
                src="../assets/img/initiation/block1/icon4.png"
              />
              <p class="text">培养创新、创造能力</p>
            </div>
          </div>
        </div>
      </div>
      <div class="block2">
        <img class="wow" src="../assets/img/initiation/block2/wow.png" />
        <div class="box">
          <img class="title" src="../assets/img/initiation/block2/title.png" />
          <div class="text">
            音乐素养AI课是音乐窝基于儿童在认知、社交、情感、沟通、行为等方面的发展特点进行设计，具有层次化和体系化。课程以音乐窝原创动画《窝仔音乐冒险记》为背景，通过智能AI，从听、说、弹、唱、玩、跳、演、创作八大维度，培养孩子的专注力、学习力、记忆力、创造力、团队协作能力等，让孩子在主人公的音乐奇妙旅程中沉浸式学习音乐、快乐成长！
          </div>
        </div>
        <img class="grass" src="../assets/img/initiation/block2/grass.png" />
        <div class="content">
          <video
            class="video"
            id="block2-video"
            controls
            src="https://wowsite.oss-cn-shenzhen.aliyuncs.com/public/homepage/new_initiation_introduction.mp4"
            poster="../assets/img/initiation/block2/poster.jpg"
          ></video>
          <!-- <img
            class="play"
            id="block2-play"
            @click="handleBlock2VideoPlay"
            src="../assets/img/initiation/block8/play.png"
          /> -->
        </div>
      </div>
      <div class="block3">
        <img class="wow" src="../assets/img/initiation/block3/wow.png" />
        <img class="star1" src="../assets/img/initiation/block3/star1.png" />
        <img class="star2" src="../assets/img/initiation/block3/star2.png" />
        <div class="content">
          <div class="box">
            <img
              class="title"
              src="../assets/img/initiation/block3/title.png"
            />
            <div class="table">
              <div class="tr">
                <div class="td"></div>
                <div class="td top1">初阶</div>
                <div class="td top2">中阶</div>
                <div class="td top3">高阶</div>
              </div>
              <div class="tr">
                <div class="td left1">
                  <p>课程<br />内容</p>
                </div>
                <div class="td mid1">
                  <p>
                    <span></span> 认识音符<br /><span></span>
                    节奏感<br /><span></span> 模唱练习<br /><span></span>
                    基本节奏型<br /><span></span> 音高概念等
                  </p>
                </div>
                <div class="td mid2">
                  <p>
                    <span></span> 五线谱<br /><span></span>
                    高音谱号<br /><span></span> 低音谱号<br /><span></span>
                    拍号<br /><span></span>
                    复杂节奏型等
                  </p>
                </div>
                <div class="td mid3">
                  <p>
                    <span></span> 大小调<br /><span></span>
                    音乐表情记号<br /><span></span> 视唱练耳等
                  </p>
                </div>
              </div>
              <div class="tr">
                <div class="td left2">
                  <p>课程<br />模块</p>
                </div>
                <div class="td mid4">
                  欣赏、演奏、游戏、故事、演唱、创作、律动
                </div>
              </div>
              <div class="tr">
                <div class="td left2">
                  <p>学习<br />形式</p>
                </div>
                <div class="td mid5">集体小班课</div>
              </div>
              <div class="tr">
                <div class="td left2">
                  <p>学习<br />周期</p>
                </div>
                <div class="td mid5">
                  <span class="orange large">118节</span>
                  趣味课堂 + <span class="orange large">2节</span>
                  毕业音乐会
                </div>
              </div>
              <div class="tr">
                <div class="td left3">
                  <p>学习<br />目标</p>
                </div>
                <div class="td mid6">
                  <div class="text">
                    <p class="orange">培养音乐技能：</p>
                    节奏律动、视唱练耳、基础乐理、乐器演奏（非洲鼓&木琴）、音乐表现力、音乐创作、建立对各类乐器的初步认知
                  </div>
                  <div class="text">
                    <p class="orange">提高软技能：</p>
                    社交能力、团队协作、自信心、专注力、学习能力、记忆力、自我管理能力
                  </div>
                </div>
              </div>
              <div class="tr">
                <div class="link" @click="toCoures">
                  衔接课程体系<img
                    class="arrow"
                    src="../assets/img/initiation/block3/arrow.png"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="block4">
        <img class="title" src="../assets/img/initiation/block4/title.png" />
        <img class="star1" src="../assets/img/initiation/block4/star1.png" />
        <img class="star2" src="../assets/img/initiation/block4/star2.png" />
        <div class="cards">
          <div class="card card1">
            <p class="tag">趣味化</p>
            <p class="text">卡通动画故事 + 游戏通关练习</p>
            <div class="content">
              <img src="../assets/img/initiation/block4/content1.png" />
            </div>
          </div>
          <div class="card card2">
            <p class="tag">益智化</p>
            <p class="text">将音乐知识融入课程各个环节</p>
            <div class="content">
              <img src="../assets/img/initiation/block4/content2.png" />
            </div>
          </div>
          <div class="card card3">
            <p class="tag">强体验</p>
            <p class="text">“AI + 音频算法”技术，学习更有趣</p>
            <div class="content">
              <img src="../assets/img/initiation/block4/content3.png" />
            </div>
          </div>
          <div class="card card4">
            <p class="tag">强互动</p>
            <p class="text">多种乐器 + 音乐，带动身体律动</p>
            <div class="content">
              <img src="../assets/img/initiation/block4/content4.png" />
            </div>
          </div>
        </div>
      </div>
      <div class="block5">
        <img class="title" src="../assets/img/initiation/block5/title.png" />
        <img class="wow" src="../assets/img/initiation/block5/wow.png" />
        <img class="wow2" src="../assets/img/initiation/block5/wow2.png" />
        <img
          class="effect1"
          src="../assets/img/initiation/block5/effect1.png"
        />
        <img
          class="effect2"
          src="../assets/img/initiation/block5/effect2.png"
        />
        <img
          class="effect3"
          src="../assets/img/initiation/block5/effect3.png"
        />
        <img
          class="effect4"
          src="../assets/img/initiation/block5/effect4.png"
        />
        <div class="cards">
          <div class="card card1">
            <img class="icon" src="../assets/img/initiation/block5/icon1.png" />
            <div class="content">
              <p class="tit">全面衔接</p>
              <p class="desp">
                课程衔接音乐窝全系列课程体系，从启蒙到专业系统培养
              </p>
            </div>
          </div>
          <div class="card card2">
            <img class="icon" src="../assets/img/initiation/block5/icon2.png" />
            <div class="content">
              <p class="tit">内容自主研发</p>
              <p class="desp">
                课程中动画、音乐、律动、插画绘本、游戏均为音乐窝原创
              </p>
            </div>
          </div>
          <div class="card card3">
            <img class="icon" src="../assets/img/initiation/block5/icon3.png" />
            <div class="content">
              <p class="tit">融入适龄乐器</p>
              <p class="desp">
                使用非洲鼓及木琴教学，更易上手，更快培养音乐基础
              </p>
            </div>
          </div>
          <div class="card card4">
            <img class="icon" src="../assets/img/initiation/block5/icon4.png" />
            <div class="content">
              <p class="tit">在“玩”中学音乐</p>
              <p class="desp">
                每节课融入音乐知识及实践，玩音乐的同时达成教学目标
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="block6">
        <img class="wow" src="../assets/img/initiation/block6/wow.png" />
        <img class="cloud1" src="../assets/img/initiation/block6/cloud1.png" />
        <img class="cloud2" src="../assets/img/initiation/block6/cloud2.png" />
        <img class="star" src="../assets/img/initiation/block6/star.png" />
        <div class="box">
          <img class="title" src="../assets/img/initiation/block6/title.png" />
          <div class="content">
            <p class="desp">
              课程研发团队由9名核心成员组成，包括教学研发、游戏策划、开发工程师、音乐制作师、编曲师、插画师、动画师，均来自专业院校、拥有丰富的专业知识及项目经验，从课程设计、研发到测试，全维度研究及优化，致力打造轻松有趣、具有探索意义的沉浸式素养课堂。
            </p>
            <div class="img">
              <img src="../assets/img/initiation/block6/member.png" />
            </div>
          </div>
        </div>
      </div>
      <div class="block7">
        <img class="title" src="../assets/img/initiation/block7/title.png" />
        <div class="swiper">
          <swiper :options="swiperOption1" ref="mySwiper1">
            <swiper-slide>
              <div class="slide">
                <img src="../assets/img/initiation/block7/scene1.jpg" />
              </div>
            </swiper-slide>
            <swiper-slide>
              <div class="slide">
                <img src="../assets/img/initiation/block7/scene2.jpg" />
              </div>
            </swiper-slide>
            <swiper-slide>
              <div class="slide">
                <img src="../assets/img/initiation/block7/scene3.jpg" />
              </div>
            </swiper-slide>
            <swiper-slide>
              <div class="slide">
                <img src="../assets/img/initiation/block7/scene4.jpg" />
              </div>
            </swiper-slide>
            <div class="swiper1-pagination" slot="pagination"></div>
          </swiper>
        </div>
      </div>
      <div class="block8">
        <img class="title" src="../assets/img/initiation/block8/title.png" />
        <img
          class="circle1"
          src="../assets/img/initiation/block8/circle1.png"
        />
        <img
          class="circle2"
          src="../assets/img/initiation/block8/circle2.png"
        />
        <div class="current">
          <img
            v-show="swiper2CurrentIndex === 0"
            src="../assets/img/initiation/block8/scene1.jpg"
          />
          <img
            v-show="swiper2CurrentIndex === 1"
            src="../assets/img/initiation/block8/scene2.jpg"
          />
          <img
            v-show="swiper2CurrentIndex === 2"
            src="../assets/img/initiation/block8/scene3.jpg"
          />
          <!-- <img class="play" src="../assets/img/initiation/block8/play.png" /> -->
        </div>
        <div class="swiper">
          <swiper :options="swiperOption2" ref="mySwiper2">
            <swiper-slide>
              <div class="slide">
                <img src="../assets/img/initiation/block8/scene1.jpg" />
              </div>
            </swiper-slide>
            <swiper-slide>
              <div class="slide">
                <img src="../assets/img/initiation/block8/scene2.jpg" />
              </div>
            </swiper-slide>
            <swiper-slide>
              <div class="slide">
                <img src="../assets/img/initiation/block8/scene3.jpg" />
              </div>
            </swiper-slide>
          </swiper>
          <div class="swiper2-button-prev" slot="button-prev"></div>
          <div class="swiper2-button-next" slot="button-next"></div>
        </div>
      </div>
      <div class="block9">
        <div class="content">
          <div class="box">
            <img
              class="title"
              src="../assets/img/initiation/block9/title.png"
            />
            <div class="list">
              <p class="text">
                <span class="tag">1</span>提供每节课精细化教程详案，助力轻松教学
              </p>
              <p class="text">
                <span class="tag">2</span
                >提供教师招聘标准和要求，协助筛选优质教师
              </p>
              <p class="text">
                <span class="tag">3</span>提供个性化市场评估、定价指导等服务
              </p>
              <p class="text">
                <span class="tag">4</span>定期开展线上答疑培训，全力扫清运营难题
              </p>
              <p class="text">
                <span class="tag">5</span
                >提供教师培训考核及回访，帮助教师轻松上岗
              </p>
              <p class="text">
                <span class="tag">6</span>提供课程配套的乐器、教具使用指导
              </p>
              <p class="text">
                <span class="tag">7</span>不定期开展名师讲座，为招生、销售赋能
              </p>
              <p class="text">
                <span class="tag">8</span>提供专家到店支持，助力机构高效运营
              </p>
              <p class="text">
                <span class="tag">9</span>提供课程顾问线下跟岗及线上销售培训指导
              </p>
              <p class="text">
                <span class="tag">10</span>提供全维度推广培训及全年活动方案
              </p>
              <p class="text">
                <span class="tag">11</span>提供客户百问百答指导及成交沟通技巧
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="block10">
        <img class="footer" src="../assets/img/initiation/block10/footer.png" />
      </div>
    </div>
    <Footer></Footer>
    <Fixed></Fixed>
  </div>
</template>

<script>
import Headers from "@/components/header.vue";
import Footer from "@/components/footer.vue";
import Fixed from "@/components/leagueFixed.vue";
export default {
  name: "initiation",
  data() {
    return {
      swiperOption1: {
        loop: true,
        autoplay: {
          disableOnInteraction: false,
        },
        pagination: {
          el: ".swiper1-pagination",
          clickable: true,
        },
      },
      swiper2CurrentIndex: 0,
      swiperOption2: {
        loop: true,
        autoplay: {
          disableOnInteraction: false,
        },
        slidesPerView: 3,
        centeredSlides: true,
        navigation: {
          nextEl: ".swiper2-button-next",
          prevEl: ".swiper2-button-prev",
        },
        on: {
          slideChangeTransitionEnd: () => {
            let swiper = this.$refs.mySwiper2.swiper;
            if (swiper) {
              this.swiper2CurrentIndex = swiper.realIndex;
            }
          },
        },
      },
    };
  },
  components: {
    Headers,
    Footer,
    Fixed,
  },
  methods: {
    toCoures() {
      this.$router.push({
        name: "Teaching",
      });
    },
    handleBlock2VideoPlay() {
      var play = document.getElementById("block2-play");
      var video = document.getElementById("block2-video");
      play.style.display = "none";
      video.play();
    },
  },
};
</script>
<style lang="sass" scoped>
.container
  padding-bottom: 55px
.center
  overflow-x: hidden
.banner
  padding-top: 60px
  height: 510px
  .img
    width: 100%
    height: 100%
/* 课程目标 */
.block1
  height: 648px
  overflow: hidden
  background-color: #E9F7FB
  .title
    text-align: center
    margin: 35px 0 34px 0
    .img
      width: 148px
      height: 57px
  .icons-wrap
    text-align: center
    .item
      display: inline-block
      vertical-align: top
      margin: 0 6px 14px 6px
      height: 186px
      width: 146px
      padding: 10px
      background: #ffffff
      border-radius: 30px
      box-shadow: 0 2px 6px 0 #cee8ff
      text-align: center
      .content
        display: inline-block
        height: 186px
        width: 146px
        border-radius: 24px
        .icon
          width: 106px
          height: 86px
          margin: 29px 20px 19px 20px
        .text
          font-size: 14px
          font-family: PingFangSC, PingFangSC-Medium
          font-weight: bold
          color: #4b2800
          line-height: 21px
/* 课程简介 */
.block2
  height: 758px
  margin-top: -20px
  background-image: url(../assets/img/initiation/block2/bg.png)
  background-size: 100%
  background-position: center top
  background-repeat: no-repeat
  padding-top: 72px
  position: relative
  .wow
    position: absolute
    top: -43px
    left: 50%
    z-index: 1
    margin-left: -57px
    width: 115px
    height: 146px
  .box
    position: relative
    z-index: 100
    margin: 0 auto 51px auto
    width: 343px
    height: 463px
    background-image: url(../assets/img/initiation/block2/box.png)
    background-size: 100%
    background-position: center top
    background-repeat: no-repeat
    text-align: center
    overflow: hidden
    .title
      display: block
      width: 148px
      height: 57px
      margin: 66px auto 34px auto
    .text
      text-align: justify
      font-size: 14px
      font-family: PingFangSC, PingFangSC-Medium
      font-weight: bold
      color: #4b2800
      line-height: 24px
      margin: 0 52px
  .grass
    position: absolute
    bottom: 256px
    left: 50%
    z-index: 1
    margin-left: -57px
    width: 115px
    height: 30px
  .content
    height: 193px
    margin: 0 16px
    background-color: #fff
    border-radius: 30px
    position: relative
    overflow: hidden
    .video
      height: 100%
      width: 100%
    .play
      width: 40px
      height: 40px
      position: absolute
      top: 0
      left: 0
      bottom: 0
      right: 0
      margin: auto
/* 课程规划 */
.block3
  height: 702px
  margin-top: -20px
  position: relative
  background-image: url(../assets/img/initiation/block3/bg.png)
  background-size: 100%
  background-position: center top
  background-repeat: no-repeat
  padding: 52px 0 10px 0
  .wow
    width: 69px
    height: 104px
    position: absolute
    top: 141px
    left: 12px
    z-index: 1
  .star1
    width: 122px
    height: 130px
    position: absolute
    top: 38px
    right: 0-15px
    z-index: 1
  .star2
    width: 83px
    height: 96px
    position: absolute
    left: -13px
    bottom: -26px
    z-index: 1
  .content
    width: 328px
    height: 681px
    margin: 0 auto
    background-color: #ffffff
    border-radius: 30px
    box-shadow: 0 2px 6px 0 #cee8ff
    padding: 10px 11px
    .box
      width: 328px
      height: 681px
      background-color: #fffbe5
      border-radius: 24px
      overflow: hidden
      .title
        display: block
        margin: 34px auto 28px auto
        width: 148px
        height: 57px
      .table
        margin: 0 9px
        .tr
          display: flex
          margin-bottom: 6px
          .td
            flex: 1
            margin-right: 5px
            color: #ffffff
            .large
              font-size: 17px
            .orange
              color: #F77622
              font-weight: bold
            &:first-child
              flex: none
              width: 40px
            &:last-child
              margin-right: 0
          .top1
            height: 40px
            line-height: 42px
            font-size: 18px
            text-align: center
            font-weight: bold
            background: linear-gradient(180deg,#fcdc4a, #f8b624)
            border-radius: 10px 10px 4px 4px
            margin-top: 18px
          .top2
            height: 48px
            line-height: 50px
            font-size: 18px
            text-align: center
            font-weight: bold
            background: linear-gradient(180deg,#fcc727, #f79511)
            border-radius: 10px 10px 4px 4px
            margin-top: 10px
          .top3
            height: 58px
            line-height: 62px
            font-size: 18px
            text-align: center
            font-weight: bold
            background: linear-gradient(180deg,#fcae47, #f77622 93%)
            border-radius: 10px 10px 4px 4px
          .left1,.left2,.left3
            display: flex
            justify-content: center
            align-items: center
            line-height: 14px
            font-size: 12px
            text-align: center
            background-color: #ADD74A
            border-radius: 10px 4px 4px 10px
          .left1
            height: 114px
          .left2
            height: 40px
          .left3
            height: 166px
          .mid1,.mid2,.mid3
            display: flex
            justify-content: center
            align-items: center
            height: 114px
            font-size: 11px
            line-height: 16px
            border-radius: 4px
            text-align: left
            span
              display: inline-block
              vertical-align: middle
              width: 3px
              height: 3px
              border-radius: 50%
              background-color: #fff
              margin-right: 3px
          .mid1
            background-color: #F8B624
          .mid2
            background-color: #F79511
          .mid3
            background-color: #F77622
          .mid4,.mid5,.mid6
            background-color: #ffffff
            border-radius: 4px
            color: #1E1E1E
          .mid4
            white-space: nowrap
            height: 40px
            line-height: 42px
            text-align: center
            font-size: 12px
          .mid5
            white-space: nowrap
            height: 40px
            line-height: 42px
            text-align: center
            font-size: 13px
          .mid6
            text-align: left
            height: 153px
            font-size: 13px
            line-height: 19px
            padding: 13px 12px 0 12px
            .text
              margin-bottom: 10px
              .orange
                font-size: 15px
          .link
            height: 40px
            line-height: 42px
            font-size: 16px
            font-weight: bold
            text-align: center
            color: #ffffff
            flex: 1
            background: #add74a
            border-radius: 10px
            .arrow
              width: 20px
              height: 20px
              display: inline-block
              vertical-align: text-bottom
/* 课程特色 */
.block4
  background-color: #E0F6FB
  padding: 24px 0 79px 0
  position: relative
  .title
    display: block
    margin: 0 auto 29px auto
    height: 57px
    width: 148px
  .star1
    width: 80px
    height: 133px
    position: absolute
    top: 9px
    right: 0
    z-index: 1
  .star2
    width: 160px
    height: 97px
    position: absolute
    bottom: -18px
    left: 108px
    z-index: 1
  .cards
    .card
      background-size: 100%
      background-position: center top
      background-repeat: no-repeat
      margin: 0 auto 2px auto
      width: 350px
      height: 360px
      overflow: hidden
      &.card1
        background-image: url(../assets/img/initiation/block4/bg1.png)
        .tag
          background: #f9c550
          box-shadow: 0 1px 5px 0 rgba(255,255,255,0.50) inset
      &.card2
        background-image: url(../assets/img/initiation/block4/bg2.png)
        .tag
          background: #F9B458
          box-shadow: 0 1px 5px 0 rgba(255,255,255,0.50) inset
      &.card3
        background-image: url(../assets/img/initiation/block4/bg3.png)
        .tag
          background: #F99F64
          box-shadow: 0 1px 5px 0 rgba(255,255,255,0.50) inset
      &.card4
        background-image: url(../assets/img/initiation/block4/bg4.png)
        height: 352px
        .tag
          margin: 66px auto 13px auto
          background: #BDDF6E
          box-shadow: 0 1px 5px 0 rgba(255,255,255,0.50) inset
      .tag
        width: 116px
        height: 30px
        line-height: 32px
        text-align: center
        font-size: 16px
        color: #ffffff
        font-weight: bold
        margin: 74px auto 13px auto
        border-radius: 15px
      .text
        text-align: center
        font-size: 15px
        line-height: 21px
        color: #1E1E1E
        margin-bottom: 16px
      .content
        width: 294px
        height: 173px
        background: #f2f2f2
        border-radius: 30px
        margin: 0 auto
        img
          width: 100%
          height: 100%
/* 课程亮点 */
.block5
  height: 881px
  position: relative
  overflow: hidden
  background-color: #E0F6FB
  background-image: url(../assets/img/initiation/block5/bg.png)
  background-size: 100%
  background-position: center bottom
  background-repeat: no-repeat
  .title
    display: block
    margin: 53px auto 0 auto
    width: 148px
    height: 57px
  .wow
    position: absolute
    top: 144px
    left: 174px
    width: 125px
    height: 156px
  .wow2
    position: absolute
    top: 215px
    left: 76px
    width: 89px
    height: 91px
  .effect1
    position: absolute
    top: 138px
    left: 63px
    width: 96px
    height: 55px
  .effect2
    position: absolute
    top: 221px
    right: 0
    width: 86px
    height: 91px
  .effect3
    position: absolute
    top: 272px
    left: 14px
    width: 65px
    height: 51px
  .effect4
    position: absolute
    top: 171px
    right: 21px
    width: 44px
    height: 44px
  .cards
    padding-top: 212px
    text-align: center
    background-image: url(../assets/img/initiation/block5/circle.png)
    background-size: 311px
    background-position: center 105px
    background-repeat: no-repeat
    .card
      display: inline-block
      width: 163px
      height: 252px
      background: #ffffff
      border-radius: 174px 174px 60px 60px
      box-shadow: 0 2px 6px 6px rgba(0,0,0,0.03)
      margin: 0 12px 20px 12px
      overflow: hidden
      font-size: 0
      &.card1
        .content
          background-color: #FFEEF5
          .tit
            color: #FF9BC4
      &.card2
        .content
          background-color: #F2FBE5
          .tit
            color: #82DD00
      &.card3
        .content
          background-color: #E6EEFF
          .tit
            color: #84ADFF
      &.card4
        .content
          background-color: #E6FAF6
          .tit
            color: #07D1AA
      .icon
        width: 93px
        height: 93px
        margin: 23px auto 18px auto
      .content
        height: 104px
        overflow: hidden
        .tit
          font-size: 16px
          line-height: 17px
          font-weight: bold
          text-align: center
          margin: 15px 0 7px 0
        .desp
          font-size: 12px
          line-height: 18px
          color: #1E1E1E
          text-align: left
          width: 132px
          margin: 0 auto
/* 研发团队 */
.block6
  height: 752px
  overflow: hidden
  position: relative
  background-color: #DCF5FD
  .wow
    position: absolute
    top: 33px
    left: 121px
    width: 148px
    height: 151px
    z-index: 101
  .cloud1
    position: absolute
    top: 33px
    left: 0
    width: 64px
    height: 169px
    z-index: 1
  .cloud2
    position: absolute
    right: 0
    bottom: 1px
    width: 59px
    height: 170px
    z-index: 1
  .star
    position: absolute
    top: 81px
    right: 0
    width: 88px
    height: 127px
    z-index: 101
  .box
    position: relative
    z-index: 100
    margin: 101px auto 0 auto
    width: 365px
    height: 633px
    background-image: url(../assets/img/initiation/block6/box.png)
    background-size: 100%
    background-position: center bottom
    background-repeat: no-repeat
    overflow: hidden
    .title
      display: block
      width: 148px
      height: 57px
      margin: 111px auto 30px auto
    .content
      margin: 0 37px
      .desp
        font-size: 14px
        line-height: 24px
        color: #4B2800
        font-weight: bold
        margin-bottom: 30px
        text-align: justify
      .img
        height: 192px
        background-color: #eeeeee
        border-radius: 30px
        overflow: hidden
        img
          width: 100%
          height: 100%
/* 教学场景 */
.block7
  height: 371px
  background-color: #fff
  overflow: hidden
  background-image: url(../assets/img/initiation/block7/circle.png)
  background-size: 144px
  background-position: right 91px
  background-repeat: no-repeat
  .title
    margin: 34px auto 34px auto
    display: block
    width: 148px
    height: 57px
  .swiper
    margin: 0 16px
    position: relative
    img
      height: 100%
      width: 100%
    .slide
      width: 343px
      height: 193px
      background: #f2f2f2
      border-radius: 30px
      margin-bottom: 12px
      overflow: hidden
    /deep/.swiper1-pagination
      bottom: 0
      position: relative
      .swiper-pagination-bullet
        margin: 0 4px
        width: 8px
        height: 8px
        background-color: #CCE9FF
        opacity: 1
      .swiper-pagination-bullet-active
        background-color: #9AD3FF
/* 教学成果 */
.block8
  height: 386px
  overflow: hidden
  background-color: #fff
  position: relative
  .circle1
    width: 112px
    height: 112px
    position: absolute
    top: 27px
    left: -37px
    z-index: 1
  .circle2
    width: 112px
    height: 112px
    position: absolute
    bottom: 31px
    right: -37px
    z-index: 1
  .title
    margin: 0 auto 37px auto
    display: block
    width: 148px
    height: 57px
    position: relative
    z-index: 100
  .current
    width: 343px
    height: 193px
    margin: 0 auto 14px auto
    position: relative
    background: #f2f2f2
    border-radius: 30px
    z-index: 100
    overflow: hidden
    img
      width: 100%
      height: 100%
    .play
      width: 40px
      height: 40px
      position: absolute
      top: 0
      left: 0
      bottom: 0
      right: 0
      margin: auto
  .swiper
    position: relative
    padding: 0 46px
    .slide
      background: #f2f2f2
      width: 84px
      height: 49px
      margin: 0 6px
      border-radius: 10px
      overflow: hidden
      img
        width: 100%
        height: 100%
    .swiper2-button-prev
      width: 30px
      height: 30px
      position: absolute
      top: 10px
      left: 9px
      z-index: 100
      background-image: url(../assets/img/initiation/block8/left.png)
      background-size: 100%
      background-position: left top
      background-repeat: no-repeat
      appearance: none
      outline: none
    .swiper2-button-next
      width: 30px
      height: 30px
      position: absolute
      top: 10px
      right: 9px
      z-index: 100
      background-image: url(../assets/img/initiation/block8/right.png)
      background-size: 100%
      background-position: left top
      background-repeat: no-repeat
      appearance: none
      outline: none
/* 服务支持 */
.block9
  padding-top: 34px
  background-color: #D7F5FE
  position: relative
  z-index: 1
  .content
    width: 326px
    height: 457px
    margin: 0 auto
    background-color: #ffffff
    border-radius: 30px
    box-shadow: 0 2px 6px 0 #cee8ff
    padding: 12px
    .box
      width: 327px
      height: 457px
      background-color: #fffbe5
      border-radius: 24px
      overflow: hidden
      .title
        margin: 32px auto
        display: block
        width: 148px
        height: 57px
      .list
        margin-left: 22px
        .text
          font-size: 13px
          line-height: 18px
          font-weight: bold
          color: #4B2800
          margin-bottom: 10px
          text-align: left
          .tag
            font-size: 12px
            line-height: 20px
            text-align: center
            display: inline-block
            vertical-align: text-bottom
            background-color: #F8B624
            margin-right: 8px
            width: 18px
            height: 18px
            border-radius: 50%
            color: #ffffff
            font-weight: 400
/* 课程合作 */
.block10
  padding-top: 29px
  background-color: #D7F5FE
  font-size: 0
  .footer
    height: 231px
    width: 100%
</style>
